export function getUserInfoFromCookie(name) {
    if (document.cookie.length > 0) {
        let c_start = document.cookie.indexOf("predamo-dms-user-info=");
        if (c_start != -1) {
            c_start = c_start + 19;
            let c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1)
                c_end = document.cookie.length;
            var userInfo = decodeURIComponent(document.cookie.substring(c_start, c_end)).replace(/\"/g, "");
            c_start = userInfo.indexOf(name + "=");
            if (c_start != -1) {
                c_start = c_start + name.length + 1;
                c_end = userInfo.indexOf(",", c_start);
                if (c_end == -1)
                    c_end = userInfo.length;
                return userInfo.substring(c_start, c_end)
            }
        }
    }
    return "";
}



// WEBPACK FOOTER //
// ./src/lib/util/user-info.js